export default __webpack_public_path__ + "static/media/2.d7dbec58.jpg";